// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var apply = /* #__PURE__ */ Control_Apply.apply(Restaumatic_Form_DynamicResult.applyDynamicResult);
var map = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var mwith = /* #__PURE__ */ Data_Monoid_Extra.mwith(Data_Monoid.monoidArray);
var filter = /* #__PURE__ */ Data_Map_Internal.filter(Restaumatic_Locales.ordLocale);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Restaumatic_Locales.ordLocale);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var unFinalFromContext = /* #__PURE__ */ Restaumatic_Form_Internal.unFinalFromContext(Restaumatic_Form_Internal.hasContextContext);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Restaumatic_Locales.ordLocale);
var alt = /* #__PURE__ */ Control_Alt.alt(Data_Maybe.altMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var TranslatedFormField = function (x) {
    return x;
};
var hasLabelTranslatedFormFie = function (dictFormFieldLike) {
    return function (dictHasLabel) {
        var getLabel = Restaumatic_Form_Internal.getLabel(dictHasLabel);
        return {
            getLabel: function (v) {
                return getLabel(v);
            }
        };
    };
};
var hasFieldIdTranslatedFormF = function (dictHasFieldId) {
    return dictHasFieldId;
};
var hasErrorsTranslatedFormFi = function (dictHasErrors) {
    return dictHasErrors;
};
var toTranslatedString = function (dict) {
    return dict.toTranslatedString;
};
var fromTranslatedString = function (dict) {
    return dict.fromTranslatedString;
};
var editingLocaleKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var editingLocale = /* #__PURE__ */ Data_Vault.singleton(editingLocaleKey);
var defaultLocaleKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var nonEmptyInDefaultLocale = function (dictHasContext) {
    var unFinalFromContext1 = Restaumatic_Form_Internal.unFinalFromContext(dictHasContext);
    return function (ctx) {
        return function (valueF) {
            return apply(map(function (v) {
                return function (v1) {
                    return mwith(v1)(function (l) {
                        var $72 = Restaumatic_I18n_Types.getLocalization(l)(v) === "";
                        if ($72) {
                            return [ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ];
                        };
                        return [  ];
                    });
                };
            })(valueF))(Restaumatic_Form_Final.liftDynamic(unFinalFromContext1(defaultLocaleKey)(ctx)));
        };
    };
};
var translatedTextInput = function (dictIsRefLike) {
    var readRefLike = Restaumatic_Form_Internal.readRefLike(dictIsRefLike);
    var writeRefLike = Restaumatic_Form_Internal.writeRefLike(dictIsRefLike);
    var touchRefLike = Restaumatic_Form_Internal.touchRefLike(dictIsRefLike);
    return function (dictHasContext) {
        var getContext = Restaumatic_Form_Internal.getContext(dictHasContext);
        return function (dictAsTranslatedString) {
            var fromTranslatedString1 = fromTranslatedString(dictAsTranslatedString);
            var toTranslatedString1 = toTranslatedString(dictAsTranslatedString);
            return function (field) {
                var update = function (locale) {
                    return function (s) {
                        return function (v) {
                            return filter(function (v1) {
                                return v1 !== "";
                            })(insert(locale)(s)(v));
                        };
                    };
                };
                var locales = bind(getContext(field))(function (context) {
                    return apply1(map1(function (v) {
                        return function (v1) {
                            return {
                                editingLocale: v,
                                defaultLocale: v1
                            };
                        };
                    })(unFinalFromContext(editingLocaleKey)(context)))(unFinalFromContext(defaultLocaleKey)(context));
                });
                var onChange = function (str) {
                    return function __do() {
                        var v = readDynamic(locales)();
                        return for_(v.editingLocale)(function (locale) {
                            return function __do() {
                                var currentValue = readDynamic(readRefLike(field))();
                                return writeRefLike(field)(new Restaumatic_Form_Internal.Valid({
                                    value: fromTranslatedString1(update(locale)(str)(Data_Maybe.maybe(Restaumatic_I18n_Types.emptyTranslated)(toTranslatedString1)(currentValue))),
                                    editValue: Data_Maybe.Nothing.value
                                }))();
                            };
                        })();
                    };
                };
                return {
                    displayedValue: apply1(map1(function (v) {
                        return function (v1) {
                            return Data_Maybe.fromMaybe("")(bind2(v1.editingLocale)(function (locale) {
                                return bind2(map2(toTranslatedString1)(v))(function (v2) {
                                    return lookup(locale)(v2);
                                });
                            }));
                        };
                    })(readRefLike(field)))(locales),
                    onChange: onChange,
                    onTouch: touchRefLike(field),
                    placeholder: apply1(map1(function (v) {
                        return function (v1) {
                            return Data_Maybe.fromMaybe("")(bind2(map2(toTranslatedString1)(v))(function (v2) {
                                return bind2(alt(bind2(v1.defaultLocale)(function (defaultLocale$prime) {
                                    return map2(Data_Tuple.Tuple.create(defaultLocale$prime))(lookup(defaultLocale$prime)(v2));
                                }))(bind2(Data_Map_Internal.findMin(v2))(function (v3) {
                                    return pure(new Data_Tuple.Tuple(v3.key, v3.value));
                                })))(function (v3) {
                                    var $91 = v3.value1 !== "";
                                    if ($91) {
                                        return pure("[" + (Restaumatic_Locales.toText(v3.value0) + ("] " + v3.value1)));
                                    };
                                    return Data_Maybe.Nothing.value;
                                });
                            }));
                        };
                    })(readRefLike(field)))(locales)
                };
            };
        };
    };
};
var isTextFieldTranslatedForm = function (dictIsRefLike) {
    var translatedTextInput1 = translatedTextInput(dictIsRefLike);
    return function (dictHasContext) {
        var translatedTextInput2 = translatedTextInput1(dictHasContext);
        return function (dictFormFieldLike) {
            return function (dictAsTranslatedString) {
                var translatedTextInput3 = translatedTextInput2(dictAsTranslatedString);
                return {
                    textInput: function (v) {
                        return translatedTextInput3(v);
                    }
                };
            };
        };
    };
};
var defaultLocale = /* #__PURE__ */ Data_Vault.singleton(defaultLocaleKey);
var asTranslatedStringTS = {
    toTranslatedString: identity,
    fromTranslatedString: identity
};
var asTranslatedStringMaybeTS = {
    toTranslatedString: /* #__PURE__ */ Data_Maybe.fromMaybe(Restaumatic_I18n_Types.emptyTranslated),
    fromTranslatedString: function (v) {
        if (Data_Map_Internal.isEmpty(v)) {
            return Data_Maybe.Nothing.value;
        };
        if (Data_Boolean.otherwise) {
            return new Data_Maybe.Just(v);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Translated (line 39, column 1 - line 43, column 25): " + [ v.constructor.name ]);
    }
};
export {
    fromTranslatedString,
    toTranslatedString,
    editingLocale,
    defaultLocale,
    editingLocaleKey,
    defaultLocaleKey,
    TranslatedFormField,
    translatedTextInput,
    nonEmptyInDefaultLocale,
    asTranslatedStringTS,
    asTranslatedStringMaybeTS,
    isTextFieldTranslatedForm,
    hasLabelTranslatedFormFie,
    hasErrorsTranslatedFormFi,
    hasFieldIdTranslatedFormF
};
